import Header from "../Header";
import jwt from "jwt-decode";
import {checkPathName} from "../../global";
import React, {useState, useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import dataProvider from "../../provider/api-interface";
import {Link} from "react-router-dom";


import Dinnerware from "../../media/images/Dinnerware.png";
import Glassware from "../../media/images/Glassware.jpg";
import TableTop from "../../media/images/Tabletop.jpg";
//import Ceramics from "../../media/images/Ceramics.png";
//import Napkins from "../../media/images/Napkins.png";
//import TableLines from "../../media/images/TableLines.png";
import TableLines from "../../media/images/Tablelinens.jpeg";


import './Categories.css';
import headerBackground from "../../media/images/GiftlistHeader.png";

import FooterCabana from "./FooterCabana";

import FurnishingsImage from "../../media/category/furnishings.svg";
import GlasswareImage from "../../media/category/glassware.svg";
import PlacematsImage from "../../media/category/placemats.svg";
import TabletopImage from "../../media/category/tabletop.svg";
import TableLinesImage from "../../media/category/table_linens.svg";
import DinnerwareImage from "../../media/category/dinnerware.svg";
import {Box, Typography} from "@mui/material";
import {useCabanaContext} from "../CabanaContext";
import StickyBar from "../StickyBar";

function Categories() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const rolePathName = window.location.pathname.split('/')[1];
    const [pathName, setPathName] = React.useState<string>(rolePathName);
    const [searchParams, setSearchParams] = useSearchParams();
    const [categories, setCategories] = useState<any>(null);

    //temp categories to use
    const [tableLinesId, setTableLinesId] = useState<number>(8);
    const [dinnerwareId, setDinnerwareId] = useState<number>(3);
    const [glasswareId, setGlasswareId] = useState<number>(4);
    const [tabletopId, setTabletopId] = useState<number>(7);

    const [activeGategories, setActiveCategories] = useState<any[]>([])

    //const [ceramicsId, setCeramicsId] = useState<number>(5);
    //const [napkinsId, setNapkinsId] = useState<number>(6);

    const listCode = searchParams.get('id');

    const token: any = localStorage.getItem('token') === null ? sessionStorage.getItem('token') : localStorage.getItem('token');
    //Use anywhere
    if(!checkPathName(pathName, token)) {
        navigate('/404');
    }

    const jwtToken = localStorage.getItem('token') === null ? sessionStorage.getItem('token') : localStorage.getItem('token');
    const decodedUser = jwt(jwtToken!);

    const [user, setUser] = useState<any>(decodedUser);

    const {
        wishlist,
        isLoadingWishlist
    } = useCabanaContext();

    const setCategoriesArray = () => {
        if(categories !== null) return;
        let categoriesArray = [];
        dataProvider.get('product/categories', jwtToken).then((response: any) => {
            if(response !== null) {
                categoriesArray = response.data;
                setCategories(categoriesArray);
                //set categories ids dinamically
                const arrayOfFoundCategories: any[] = [];
                categoriesArray.map((category: any) => {
                    switch (category.name_en.toLowerCase()){
                        case 'furnishings':
                            arrayOfFoundCategories.push({
                                id: category.id,
                                label: 'FURNISHINGS',
                                image: FurnishingsImage,
                                position: 5
                            })
                            break;
                        case 'glassware registry':
                            arrayOfFoundCategories.push({
                                id: category.id,
                                label: 'GLASSWARE',
                                image: GlasswareImage,
                                position: 2
                            })
                            break;
                        case 'placemats registry':
                            arrayOfFoundCategories.push({
                                id: category.id,
                                label: 'PLACEMATS',
                                image: PlacematsImage,
                                position: 4
                            })
                            break;
                        case 'tabletop registry':
                            arrayOfFoundCategories.push({
                                id: category.id,
                                label: 'TABLETOP',
                                image: TabletopImage,
                                position: 3
                            })
                            break;
                        case 'table linens registry':
                            arrayOfFoundCategories.push({
                                id: category.id,
                                label: 'TABLE LINENS',
                                image: TableLinesImage,
                                position: 0
                            })
                            break;
                        case 'dinnerware registry':
                            arrayOfFoundCategories.push({
                                id: category.id,
                                label: 'DINNERWARE',
                                image: DinnerwareImage,
                                position: 1
                            })
                            break;
                    }
                    setActiveCategories(arrayOfFoundCategories.sort((a, b) => a.position - b.position))
                });
            }
        });
    }

    useEffect(() => {
        setCategoriesArray();
    }, []);
    //End use anywhere

    let wishlistUrl = null;
    if(user.role === 1){
        wishlistUrl = `/${pathName}/registry/${listCode}`;
    } else {
        wishlistUrl = `/${pathName}/${listCode}`;
    }
    // return (
    //     <div className="Categories">
    //         <Header /*hideLanguageSelect={user.role === 2}*/ wishlistUrl={wishlistUrl} link={`/${pathName}/registry/${listCode}`}
    //                                                          textLink={t('header.home')} hideLogout={true} showWishlistLink={true}/>
    //         <div className="row no-gutter">
    //             <div className="CategoriesContainer MultipleCategories col-12 d-md-flex d-none">
    //                 <div className="CategoriesTitle">
    //                     <h1>{t('categoriesTitle')}</h1>
    //                 </div>
    //                 <div className="TopCategoriesContainer">
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${tableLinesId}`}
    //                           style={{background: `url(${TableLines}),lightgray 10%`}} className="TopCategory1">
    //                         <div className="CategoryNameContainer">
    //                             <span>Table linens</span>
    //                         </div>
    //                     </Link>
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${dinnerwareId}`} className="TopCategory2"
    //                           style={{background: `url(${Dinnerware}),lightgray 50%`}}>
    //                         <div>
    //                             <div className="CategoryNameContainer">
    //                                 <span>Dinnerware</span>
    //                             </div>
    //                         </div>
    //                     </Link>
    //                 </div>
    //                 <div className="BottomCategoryContainer">
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${glasswareId}`}
    //                           style={{backgroundImage: `url(${Glassware})`, backgroundColor: '#f2f2f4', backgroundSize: 'cover'}} className="BottomCategory1">
    //                         <div className="CategoryNameContainer">
    //                             <span>Glassware</span>
    //                         </div>
    //                     </Link>
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${tabletopId}`}
    //                           style={{backgroundImage: `url(${TableTop})`,backgroundColor: '#f2f2f4', backgroundSize: 'cover'}} className="BottomCategory2">
    //                         <div className="CategoryNameContainer">
    //                             <span>Tabletop</span>
    //                         </div>
    //                     </Link>
    //                 </div>
    //             </div>
    //             <div className="CategoriesContainer MobileCategories MultipleCategories col-12 d-md-none d-flex">
    //                 <div className="CategoriesTitle">
    //                     <h1>{t('categoriesTitle')}</h1>
    //                 </div>
    //                 <div className="MiddleCategoriesContainer">
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${tableLinesId}`}
    //                           style={{background: `url(${TableLines}),lightgray 50%`}} className="MiddleCategory1">
    //                         <div className="CategoryNameContainer">
    //                             <span>Table Linens</span>
    //                         </div>
    //                     </Link>
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${dinnerwareId}`} className="MiddleCategory2"
    //                           style={{background: `url(${Dinnerware}),lightgray 50%`}}>
    //                         <div>
    //                             <div className="CategoryNameContainer">
    //                                 <span>{t('dinnerware')}</span>
    //                             </div>
    //                         </div>
    //                     </Link>
    //                 </div>
    //                 <div className="BottomCategoryContainer">
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${glasswareId}`}
    //                           style={{backgroundImage: `url(${Glassware})`, backgroundColor: '#f2f2f4', backgroundSize: 'cover'}} className="BottomCategory1">
    //                         <div className="CategoryNameContainer">
    //                             <span>Glassware</span>
    //                         </div>
    //                     </Link>
    //                     <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${tabletopId}`}
    //                           style={{backgroundImage: `url(${TableTop})`,backgroundColor: '#f2f2f4', backgroundSize: 'cover'}} className="BottomCategory2">
    //                         <div className="CategoryNameContainer">
    //                             <span>Tabletop</span>
    //                         </div>
    //                     </Link>
    //                 </div>
    //             </div>
    //         </div>
    //         <FooterCabana showDisclaimer={false}/>
    //     </div>
    // );

    return(
        <div className="Categories">
            <Header /*hideLanguageSelect={user.role === 2}*/ wishlistUrl={wishlistUrl} link={`/${pathName}/registry/${listCode}`}
                                                             textLink={t('header.home')} hideLogout={true} showWishlistLink={true}/>
            <StickyBar/>
            <Typography className={'category-title'}>
                {t('categoriesTitle')}
            </Typography>
            <Box className={'container-categories'}>
                {activeGategories.map((category) => (
                    <Box className={'category-box'} key={category.id}>
                        <Link to={`/${pathName}/registry/catalogue?id=${listCode}&categoryId=${category.id}`}>
                        <Box className={'category-container-image'}>
                            <img src={category.image} alt={'category-image'}/>
                        </Box>
                        <Typography className={'name-of-category'}>
                            {category.label}
                        </Typography>
                        </Link>
                    </Box>
                ))}
            </Box>
            <FooterCabana showDisclaimer={false}/>
        </div>
    )
}

export default withTranslation()(Categories);